
document.addEventListener('DOMContentLoaded',()=>{
 const menu=document.getElementById('menu'),links=document.getElementById('links');
 if(menu&&links){menu.addEventListener('click',()=>{const open=links.classList.toggle('open');menu.setAttribute('aria-expanded',String(open));});links.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>links.classList.remove('open'))); const trigger=links.querySelector('.rv2-nav-trigger'); const dropdown=links.querySelector('.rv2-nav-dropdown'); if(trigger&&dropdown){trigger.addEventListener('click',()=>{const open=dropdown.classList.toggle('is-open'); trigger.setAttribute('aria-expanded',String(open));});}}
 const slides=[...document.querySelectorAll('.slide')],dots=document.getElementById('dots');let current=0,timer;
 function show(i){if(!slides.length)return;current=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('active',n===current));if(dots)[...dots.children].forEach((d,n)=>d.classList.toggle('active',n===current));clearInterval(timer);timer=setInterval(()=>show(current+1),5000)}
 if(slides.length&&dots){slides.forEach((_,i)=>{const d=document.createElement('span');d.className='dot'+(i===0?' active':'');dots.appendChild(d);d.addEventListener('click',()=>show(i));});document.getElementById('next')?.addEventListener('click',()=>show(current+1));document.getElementById('prev')?.addEventListener('click',()=>show(current-1));timer=setInterval(()=>show(current+1),5000);}
 const observer=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible')}),{threshold:.12});document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));
 const q=document.getElementById('quoteForm');if(q)q.addEventListener('submit',e=>{e.preventDefault();const d=new FormData(q);location.href=`mailto:sales@ryvikforged.com?subject=${encodeURIComponent('Ryvik build inquiry — '+d.get('vehicle'))}&body=${encodeURIComponent([...d.entries()].map(([k,v])=>k+': '+v).join('\n'))}`});
});

/* Ryvik Forged cart badge
   One source of truth: the completed /cart.js response.
   The visible value is the number of unique Construction + Wheel Model pairs.
   Quantities, line keys, variants, product IDs, properties other than those two,
   sizes, offsets, and finishes never contribute to the count. */
(() => {
  if (window.__ryvikWheelStyleBadgeController) return;

  const SELECTOR = '[data-ryvik-wheel-style-badge]';
  const CART_MUTATION = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/;
  const state = { count: null, refreshToken: 0, animationTimer: 0 };

  const clean = (value) => String(value || '')
    .toLowerCase()
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, ' ')
    .trim();

  const normalizeConstruction = (value) => {
    const text = clean(value);
    if (/beadlock/.test(text)) return 'beadlock';
    if (/(?:2|two)\s*-?\s*piece/.test(text)) return '2-piece';
    if (/monoblock/.test(text)) return 'monoblock';
    return '';
  };

  const normalizeModel = (value) => {
    const text = clean(value);
    if (!text) return '';
    const match = text.match(/\b(?:rf\s*-?\s*)?\d{3,4}[a-z]?\b/i) || text.match(/\b\d{3,4}[a-z]?\b/i);
    if (!match) return '';
    const raw = match[0].replace(/\s+/g, '').toLowerCase();
    return raw.startsWith('rf') ? raw.replace(/^rf-?/, 'rf-') : raw;
  };

  const parseFromItemMetadata = (item) => {
    const sources = [
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url,
      item && item.product_type,
      item && item.vendor
    ].filter(Boolean).join(' ');
    const construction = normalizeConstruction(sources);
    const model = normalizeModel(sources);
    return construction && model ? `${construction}|${model}` : null;
  };

  const propertyValue = (properties, names) => {
    const entries = Object.entries(properties || {});
    for (const wanted of names) {
      const found = entries.find(([key]) => clean(key).replace(/^_+/, '') === clean(wanted));
      if (found && found[1] != null) return found[1];
    }
    return '';
  };

  const styleKey = (item) => {
    const properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    const propertyConstruction = propertyValue(properties, ['Construction']);
    const propertyModel = propertyValue(properties, ['Wheel Model', 'Wheel Style', 'Model']);
    const construction = normalizeConstruction(propertyConstruction) || normalizeConstruction([
      item && item.product_type,
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url
    ].filter(Boolean).join(' '));
    const model = normalizeModel(propertyModel) || normalizeModel([
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url
    ].filter(Boolean).join(' '));
    if (construction && model) return `${construction}|${model}`;
    return parseFromItemMetadata(item);
  };

  const distinctStyleCount = (items) => {
    const styles = new Set();
    (Array.isArray(items) ? items : []).forEach((item) => {
      if (item && item.properties && String(item.properties._ryvik_shipping_fee || '').toLowerCase() === 'true') return;
      const key = styleKey(item);
      if (key) styles.add(key);
    });
    return styles.size;
  };

  const render = (count, animate) => {
    const next = Math.max(0, Number.parseInt(count, 10) || 0);
    const changed = state.count !== null && state.count !== next;
    state.count = next;

    document.querySelectorAll(SELECTOR).forEach((badge) => {
      badge.textContent = next ? String(next) : '';
      badge.hidden = next === 0;
      badge.setAttribute('aria-label', `${next} distinct wheel ${next === 1 ? 'style' : 'styles'} in cart`);
      badge.classList.remove('is-updating', 'is-visible-change');
      if (animate && changed && next > 0) {
        void badge.offsetWidth;
        badge.classList.add('is-visible-change');
      }
    });
  };

  const readCart = async () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await nativeFetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Cart badge refresh failed.');
    return response.json();
  };

  const refresh = async (animate = false) => {
    const token = ++state.refreshToken;
    try {
      const cart = await readCart();
      if (token !== state.refreshToken) return state.count;
      render(distinctStyleCount(cart.items), animate);
    } catch (_) {
      // Keep the last confirmed value. Never substitute Shopify quantity.
    }
    return state.count;
  };

  const scheduleRefresh = (animate) => {
    window.clearTimeout(state.animationTimer);
    state.animationTimer = window.setTimeout(() => refresh(Boolean(animate)), 0);
  };

  const nativeFetch = window.fetch.bind(window);
  window.fetch = async function(input, init) {
    const response = await nativeFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (response.ok && CART_MUTATION.test(url)) {
        const isAddition = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
        // Refresh only after Shopify has completed the mutation response.
        scheduleRefresh(isAddition);
      }
    } catch (_) {}
    return response;
  };

  window.ryvikCartBadge = Object.freeze({ refresh });
  window.ryvikAnimateCartAddition = () => {
    window.clearTimeout(state.animationTimer);
    return refresh(true);
  };
  window.__ryvikWheelStyleBadgeController = true;

  const start = () => refresh(false);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Shopify product media gallery. Product uploads take priority over theme fallbacks. */
(() => {
  const initProductGalleries = (root = document) => {
    root.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.mediaGalleryReady === 'true') return;
      const mainImage = gallery.querySelector('#mainProductImage');
      const thumbnails = [...gallery.querySelectorAll('[data-product-gallery-thumbnail]')];
      if (!mainImage || !thumbnails.length) return;

      gallery.dataset.mediaGalleryReady = 'true';
      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const nextSource = thumbnail.dataset.gallerySrc;
          if (!nextSource || thumbnail.classList.contains('active')) return;

          const nextImage = new Image();
          nextImage.onload = () => {
            mainImage.classList.add('is-switching');
            window.setTimeout(() => {
              mainImage.src = nextSource;
              mainImage.alt = thumbnail.dataset.galleryAlt || '';
              thumbnails.forEach((item) => {
                const active = item === thumbnail;
                item.classList.toggle('active', active);
                item.setAttribute('aria-current', active ? 'true' : 'false');
              });
              window.requestAnimationFrame(() => mainImage.classList.remove('is-switching'));
            }, 110);
          };
          nextImage.src = nextSource;
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductGalleries(), { once: true });
  } else {
    initProductGalleries();
  }
  document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));
})();


/* Seamless marquee loop.
   Measures one complete phrase group, then duplicates that exact group enough
   times to cover wide screens. The animation moves by exactly one group width,
   so the reset point is visually identical and never exposes an empty gap. */
(() => {
  const initMarquees = () => {
    document.querySelectorAll('.marquee-track').forEach((track) => {
      const original = track.querySelector('.marquee-group');
      if (!original) return;

      const rebuild = () => {
        track.style.animation = 'none';
        [...track.querySelectorAll('.marquee-group')].slice(1).forEach((group) => group.remove());
        original.removeAttribute('aria-hidden');

        const groupWidth = Math.ceil(original.getBoundingClientRect().width);
        if (!groupWidth) return;

        const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const copiesNeeded = Math.max(2, Math.ceil(viewportWidth / groupWidth) + 2);
        for (let index = 1; index < copiesNeeded; index += 1) {
          const clone = original.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }

        const pixelsPerSecond = 58;
        track.style.setProperty('--marquee-shift', `${groupWidth}px`);
        track.style.setProperty('--marquee-duration', `${Math.max(12, groupWidth / pixelsPerSecond)}s`);
        void track.offsetWidth;
        track.style.animation = '';
      };

      rebuild();
      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(rebuild, 150);
      }, { passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquees, { once: true });
  } else {
    initMarquees();
  }
})();
